import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategorySection from './components/CategorySection';
import LatestArticles from './components/LatestArticles';
import PhotoGallery from './components/PhotoGallery';
import FAQSection from './components/FAQSection';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '校园春色',
      url: 'https://qinglanriyu.cn',
      description: '记录青春校园里最美好的四季风光与青春故事',
      email: 'hello@qinglanriyu.cn',
      sameAs: [
        'https://weixin.qq.com',
        'https://weibo.com',
        'https://xiaohongshu.com',
      ],
    },
    {
      '@type': 'WebSite',
      name: '校园春色',
      url: 'https://qinglanriyu.cn',
      description: '记录青春校园里最美好的四季风光与青春故事，感受校园生活的纯真与美好',
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://qinglanriyu.cn/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: '校园春色 - 首页',
      description: '校园春色，记录青春校园里最美好的四季风光与青春故事。从春日樱花盛开到秋叶飘落，感受校园生活的纯真与美好。',
      url: 'https://qinglanriyu.cn',
      isPartOf: { '@id': 'https://qinglanriyu.cn/#website' },
      about: { '@id': 'https://qinglanriyu.cn/#organization' },
      primaryImageOfPage: {
        '@type': 'ImageObject',
        url: 'https://readdy.ai/api/search-image?query=Beautiful%20university%20campus%20spring%20scenery%20cherry%20blossoms%20warm%20sunlight&width=1200&height=630&seq=og-home&orientation=landscape',
      },
    },
  ],
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body">
      <SEOHead
        title="校园春色——青春校园生活美好瞬间全记录"
        description="校园春色，记录青春校园里最美好的四季风光与青春故事。从春日樱花盛开到秋叶飘落，感受校园生活的纯真与美好，重温那段难忘的青葱岁月，让每一帧校园春色都成为永恒的记忆。"
        keywords="校园春色,校园春色摄影,青春校园生活,校园四季风光,校园美好瞬间,校园青春记忆,校园风景欣赏"
        canonicalUrl="/"
        ogType="website"
        jsonLd={homeJsonLd}
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturedArticles />
        <CategorySection />
        <LatestArticles />
        <PhotoGallery />
        <FAQSection />
      </main>

      <Footer />
      <ScrollToTop />
    </div>
  );
}